const tableCellServiceType = {
  Typography: 'Deseja realmente deletar este item?'
};

export default tableCellServiceType;
